<template>
  <div class="scriptsExamineListContainer">
    <ul class="tabs">
      <li :class="{ active: activeName === '0' }" @click="handleTypeClick('0')">
        全部
      </li>
      <li :class="{ active: activeName === '1' }" @click="handleTypeClick('1')">
        图文
      </li>
      <li :class="{ active: activeName === '2' }" @click="handleTypeClick('2')">
        视频
      </li>
      <li :class="{ active: activeName === '3' }" @click="handleTypeClick('3')">
        图集
      </li>
    </ul>
    <!--    筛选栏-->
    <div class="searchContainer">
      <!--      <el-date-picker-->
      <!--          v-model="searchDuration"-->
      <!--          type="daterange"-->
      <!--          align="right"-->
      <!--          unlink-panels-->
      <!--          range-separator="至"-->
      <!--          start-placeholder="开始日期"-->
      <!--          end-placeholder="结束日期"-->
      <!--          value-format="timestamp"-->
      <!--          @change="handleTypeClick"-->
      <!--      >-->
      <!--      </el-date-picker>-->
      <el-input
        placeholder="请输入关键词"
        v-model="searchKey"
        clearable
        class="searchKeyInput"
        @change="handleSearch"
      >
      </el-input>
    </div>
    <div class="innerContainer">
      <ul class="scriptList">
        <li v-for="(item, index) in list" :key="index">
          <div class="cover-container" v-if="item.nd_cover_url.length > 0">
            <el-image
              fit="cover"
              :src="item.nd_cover_url[0]"
              :preview-src-list="item.nd_cover_url"
              class="cover"
            />
          </div>
          <div class="info-box">
            <div class="infoContainer">
              <p class="title" @click="toDetail(item)">{{ item.nd_title }}</p>
              <p class="date">{{ item.nd_create_time }}</p>
            </div>
            <div class="infoContainer action-bar">
              <p></p>
              <p class="btns">
                <span @click="toEdit(item)">修改</span>
                <span @click="deleteFn(item)">删除</span>
              </p>
            </div>
          </div>
        </li>
      </ul>
      <el-empty description="暂无内容" v-if="list.length === 0" />
      <el-pagination
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
      <div class="clear"></div>
    </div>

    <el-dialog
      title="请完成实名认证"
      :visible.sync="certificationVisible"
      class="certificationInfoContainer"
      width="1026px"
    >
      <p class="title">
        应网络实名制要求，完成实名认证后才可以发表文章视频等内容，以保护账号安全。
      </p>
      <div class="borderContainer">
        <div>
          <p class="infoTitle">1、打开“顶端新闻”App</p>
          <p class="info">登录当前账号或扫下方二维码下载“顶端新闻”App</p>
          <img
            src="../../../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="infoTitle">2、打开“我的”</p>
          <p class="info">点击“实名认证”完成实名认证</p>
          <img
            src="../../../assets/shiming@2x.png"
            class="app"
            v-if="u_cert != 1"
          />
          <img src="../../../assets/shenqing@2x.png" class="app" v-else />
        </div>
      </div>
    </el-dialog>

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      :allowClose="true"
      @closeBan="isBanned = false"
    ></BanDialog>
  </div>
</template>

<script>
import { RESOURCE_HOST } from "../../../constants/apiHosts";
import BanDialog from "../../../components/banDialog.vue";

export default {
  data() {
    return {
      activeName: "0",
      list: [],
      pageSize: 10,
      currentPage: 1,
      total: 1,
      searchDuration: "",
      searchKey: "",
      u_cert: 0,
      u_cert_status: 0,
      certificationVisible: false,
      isBanned: false,
    };
  },
  components: {
    BanDialog,
  },
  created() {
    this.u_cert_status = localStorage.getItem("u_cert_status");
    this.u_cert = localStorage.getItem("u_cert");

    setTimeout(() => {
      this.u_cert_status = localStorage.getItem("u_cert_status");
      this.u_cert = localStorage.getItem("u_cert");
    }, 3000);

    this.getList();
  },
  mounted() {},
  methods: {
    handleTypeClick(type) {
      this.activeName = type;
      this.currentPage = 1;
      this.getList();
    },
    handleSearch: function () {
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      let url = `${RESOURCE_HOST}/api/draft/search?type=${this.activeName}&page=${this.currentPage}&size=${this.pageSize}&title=${this.searchKey}`;
      this.$axios.get(url).then((res) => {
        if (res.data.code == 0) {
          this.list = res.data.data.returnData;
          if (this.currentPage == 1) {
            this.total = res.data.data.count;
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();

      document.getElementsByTagName("html")[0].scrollTop = 0;
    },
    toDetail(item) {
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: {
          draftId: item.nd_id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    toEdit(item) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      let banData = localStorage.getItem("banData");
      if (banData) {
        banData = JSON.parse(banData);
      }
      if (banData.ban_type == 1 && banData.ban_range_type.indexOf("1") > -1) {
        this.$refs.banShow.getReason(localStorage.getItem("token"));
        this.isBanned = true;
        return;
      }

      if (item.nd_type == 1) {
        //打开新的窗口
        let routeData = this.$router.resolve({
          path: "/scriptWrite",
          query: {
            draftId: item.nd_id,
          },
        });
        window.open(routeData.href, "_blank");
      } else if (item.nd_type == 2) {
        let routeData = this.$router.resolve({
          path: "/videoWrite",
          query: {
            draftId: item.nd_id,
          },
        });
        window.open(routeData.href, "_blank");

        /* this.$router.push({
          path: "/videoWrite",
          query: {
            draftId: item.nd_id,
          },
        }); */
      } else if (item.nd_type == 3) {
        let routeData = this.$router.resolve({
          path: "/graphWrite",
          query: {
            draftId: item.nd_id,
          },
        });
        window.open(routeData.href, "_blank");

        /* this.$router.push({
          path: "/graphWrite",
          query: {
            draftId: item.nd_id,
          },
        }); */
      }
    },
    deleteFn(item) {
      if (this.u_cert != 1) {
        this.certificationVisible = true;
        return;
      }
      this.$confirm("确定要删除该条草稿吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(`${RESOURCE_HOST}/api/draft/del`, {
              ids: item.nd_id,
              global_ids: item.global_id,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.getList();

                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables";

.scriptsExamineListContainer {
  padding: 0 32px 20px 32px;
  position: relative;
  background-color: #ffffff;
  //box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  border-radius: 8px;

  .tabs {
    display: flex;
    height: 71px;
    border-bottom: 1px solid #eeeeee;
    width: calc(100% + 64px);
    margin-left: -32px;

    li {
      margin: 0 28px;
      font-size: 18px;
      color: #333333;
      cursor: pointer;
      line-height: 69px;
    }
    li.active {
      border-bottom: 3px solid #ea0e0e;
    }
  }
  .searchContainer {
    margin-top: 32px;
    display: flex;
    align-items: center;

    .el-input {
      width: 220px;
      margin: 0;
    }

    .el-date-editor {
      width: 250px;
      margin-right: 10px;
    }
  }

  /deep/.el-tabs__nav-wrap::after {
    height: 0;
  }

  /deep/.el-tabs__header {
    margin-bottom: 0;
    border-bottom: 1px solid #edf1f8;
  }

  /deep/.el-tabs__nav {
    padding-bottom: 10px;

    .el-tabs__item {
      font-size: 18px;
      color: $text-color-main;
    }
  }

  .innerContainer {
    min-height: calc(100vh - 120px);
    padding: 15px 0 0 0;
    border-radius: 5px;

    .el-pagination {
      float: right;
      margin: 20px 0 0 0;
    }

    .searchKeyInput {
      width: 180px;
    }

    .scriptList {
      li {
        border-bottom: 1px solid #edf1f8;
        padding: 16px 0;
        display: flex;
        box-sizing: content-box;
        min-height: 90px;

        .cover-container {
          width: 160px;
          height: 90px;
          background: $img-bg-color;
          border-radius: 6px;
          overflow: hidden;
          margin-right: 20px;

          .cover {
            width: 100%;
            height: 100%;
          }
        }

        .info-box {
          flex: 1;
          position: relative;

          .infoContainer {
            display: flex;
            justify-content: space-between;

            .title {
              font-size: 16px;
              color: $text-color-main;
              font-weight: bold;
              width: calc(100% - 180px);
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              cursor: pointer;
            }

            .date {
              font-size: 14px;
              color: #999999;
            }

            span {
              font-size: 14px;
              color: #5574e7;
              cursor: pointer;
              margin-left: 20px;
            }
          }

          .infoContainer.action-bar {
            position: absolute;
            bottom: 0;
            right: 0;
          }
        }
      }
    }
  }

  .certificationInfoContainer {
    /deep/.el-dialog__header {
      padding: 20px 32px;

      .el-dialog__title {
        font-size: 16px;
        font-family: PingFang-SC-Heavy, PingFang-SC;
        font-weight: 800;
        color: #333333;
        line-height: 22px;
      }
    }

    /deep/.el-dialog__body {
      padding: 10px 32px 41px 32px;

      .title {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-bottom: 20px;
      }

      .borderContainer {
        height: 255px;
        border-radius: 6px;
        border: 1px solid #dcdfe6;
        display: flex;
        padding: 28px 32px 0 32px;
        justify-content: space-between;

        div {
          flex: 1;

          .infoTitle {
            font-size: 16px;
            font-family: PingFang-SC-Heavy, PingFang-SC;
            font-weight: 800;
            color: #333333;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .info {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 22px;
          }

          .qrCode {
            width: 118px;
            margin: 22px 0 0 117px;
          }

          .app {
            width: 198px;
            margin: 20px 0 0 43px;
          }
        }
      }
    }
  }
}
</style>
